var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"charts"},[_c('vue-highcharts',{ref:"pieChart",attrs:{"options":_vm.options,"highcharts":_vm.Highcharts}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }